/**
 * Collection operator sealed projection — Family C read-only surface labels.
 */

export const COLLECTION_OPERATOR_PROJECTION_LABELS = {
  pageTitle: '수금 운영자 투영(읽기 전용)',
  pageSubtitle:
    '봉인된 ProjectionProfile을 통해 파생된 운영자 읽기 화면입니다. 권한·승인·원장 진실을 부여하지 않습니다.',
  loadFailed: '운영자 투영을 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
  missingArEntryId: 'AR 항목 ID가 필요합니다.',
  retry: '다시 시도',
  readOnlyBanner: '읽기 전용 — 이 화면에서는 조치·승인·집행을 실행할 수 없습니다.',
  noAuthority: '투영 가시성은 실행 권한을 부여하지 않습니다 (grantsAuthority=false).',
  freshness: '신선도',
  drift: '드리프트',
  generatedAt: '생성 시각',
  projectionHash: '투영 해시',
  profile: '프로파일',
  audience: '오디언스',
  ruleset: '규칙셋',
  customerAccount: '고객/계정',
  overdue: '연체 여부',
  stage: '현재 수금 단계',
  creditHold: '신용 보류 상태',
  nextActionDate: '다음 필요 조치일',
  commitments: '약속 상태',
  approvalReadOnly: '승인/해석(읽기 전용)',
  evidence: '소스 증거 참조',
  provenance: '프로비넌스',
  knownOmissions: '알려진 생략',
  caveats: '주의사항',
  freshnessCurrent: 'CURRENT (신선)',
  freshnessStale: 'STALE',
  freshnessFailed: 'FAILED / 소스 불가',
  freshnessSuperseded: 'SUPERSEDED (재구축 필요)',
  freshnessOther: '기타',
} as const;
